module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Communication/Urgent-mail-9e79b9baf0607608c819056aa4398237.svg";